import React from "react";
import { connect } from "react-redux";
import { Icon } from "semantic-ui-react";
import { hideCookiesBar } from "../../actions/userActions";
import { COOKIES_BAR_MESSAGE } from "../../constants/messages";
import "./index.css";

const CookiesBar = props => {
  const { actions } = props;
  return (
    <div className="cookiesbar">
      <div className="content">
        <div className="message">{COOKIES_BAR_MESSAGE}</div>
        <div className="close-banner" onClick={actions.hideCookiesBar}>
          <Icon color="black" name="close" size="large" />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  actions: {
    hideCookiesBar: () => dispatch(hideCookiesBar()),
  },
});

export default connect(null, mapDispatchToProps)(CookiesBar);



// WEBPACK FOOTER //
// ./src/components/CookiesBar/index.js